
//========================================================================================
/*

  style     [obj]
  isOpen    [bool]
 
 */
//========================================================================================



import Modal from 'react-modal';
import React from 'react';
import { ModalWrapper } from './styles';

const generalModalStyles = {
  overlay: {
    backgroundColor: 'rgba(58, 61, 77, 0.5)',
    zIndex: 10
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    padding: '15px 15px 15px 30px',
    transform: 'translate(-50%, -50%)',
    maxWidth: '27em',
    width: '80%',
    maxHeight: '90vh'
  }
};

const concatStyles = style => {
  return style
    ? {
      overlay: { ...generalModalStyles.overlay, ...(style.overlay || {}) },
      content: { ...generalModalStyles.content, ...(style.content || {}) }
    }
    : generalModalStyles;
};

export default props => {
  const body = body || document.getElementsByTagName('body')[0];
  if (props && props.isOpen) {
    const app = document.getElementById('app');
    const scrollWidth = window.innerWidth - app.clientWidth;
    const hasVerticalScrollbar = body.scrollHeight > body.clientHeight;
    body.setAttribute(
      'style',
      `overflow: hidden; padding-right: ${hasVerticalScrollbar ? scrollWidth + 'px' : '0'}`
    );
  } else if (!props.isOpen && window.getComputedStyle(body).overflow === 'hidden') {
    body.setAttribute('style', 'overflow: auto; padding-right: 0}');
  }

  return (
    <Modal {...props} style={concatStyles(props.style)}>
      <ModalWrapper>{props.children}</ModalWrapper>
    </Modal>
  );
};
